<template>
  <div class="box">
    <div class="login">
      <!-- 文字 -->
      <div class="loginTitle">短信登录11</div>
      <!-- 登录表单 -->
      <van-cell-group class="group">
        <van-field
          v-model="username"
          placeholder="请输入手机号1"
          maxlength="11"
          @blur="reg"
          class="group_phon"
        />
        <van-field
          v-model="password"
          center
          clearable
          placeholder="验证码"
          @blur="word"
          class="group_word"
        >
          <van-button
            slot="button"
            size="small"
            class="login-button"
            @click="getCode"
            :text="btnTitle"
            :disabled="disabled1"
          ></van-button>
        </van-field>
        <button class="login-form-button" @click="login" :disabled="disabled">登录</button>
        <van-checkbox
          class="checkbox"
          icon-size="15px"
          checked-color="rgba(116, 180, 43, 1)"
          v-model="checked"
          shape="square"
        >
          我已阅读并同意
          <a href="javascript:void(0)" class="protocol" @click.stop="protpcol">客户服务协议</a>
        </van-checkbox>
        <p class="login_pass_p">
          <span @click="goPassLogin">使用密码登录</span>
        </p>
        <p />
      </van-cell-group>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      checked: true,
      patt: /^1[0-9]{10}$/,
      disabled: true,
      disabled1: false,
      btnTitle: "获取验证码",
      companyId: ""
    };
  },
  // 禁止按钮使用
  watch: {
    username(value) {
      if (this.patt.test(value)) {
        this.disabled = false;
      }
    }
  },
  created() {
    localStorage.removeItem("token");
    this.username = localStorage.getItem("username");
    this.companyId = this.$route.query.companyId;
    if (this.username == null) {
      this.username = ''
    }
  },
  methods: {
    // 服务协议转跳
    protpcol() {
      localStorage.setItem("username", this.username);
      this.$router.push({ path: "/protocol" });
    },
    // 登录
    login() {
      if (this.checked === true) {
        if (!this.companyId) {
          this.companyId = 1;
        }
        this.$axios
          .get(
            `/auth/oauth/token?username=${this.username}&password=${this.password}&grant_type=password&client_id=cumMobile&client_secret=cum&auth_type=cumMobile&companyId=${this.companyId}`
          )
          .then(res => {
            // 获取并存储token
            const token = res.data.token_type + " " + res.data.access_token;
            localStorage.setItem("token", token);
            // 获取并存储customerId
            this.$axios
              .get("/customer/customer/info")
              .then(ress => {
                this.customerId = ress.data.data.customerId;
                localStorage.setItem("customerId", this.customerId);
                if (res.status === 200) {
                  this.$router.push("/index");
                  localStorage.removeItem("username");
                }
              })
              .catch(err => {
                this.$toast("手机号或者验证码错误");
                return err;
              });
          });
      } else {
        this.$toast("请勾选我已阅读");
      }
    },
    goPassLogin() {
      // 密码登录
      this.$router.push({
        path: "/accountLogin",
        query: { companyId: this.companyId }
      });
    },
    // 校验手机号
    reg() {
      if (!this.patt.test(this.username)) {
        this.$toast("请输入正确的手机号");
      }
    },
    // 校验验证码
    word() {
      if (this.password === "") {
        this.$toast("请输入验证码");
      }
    },
    getCode() {
      this.$axios
        .get(
          `/auth/smsAuth/code?action=login&authType=2&mobile=${this.username}`
        )
        .then(res => {
          if (res.data.code == 1) {
            this.$toast(res.data.msg);
          } else if (res.data.code == 0) {
            //倒计时
            let time = 60;
            let timer = setInterval(() => {
              if (time == 0) {
                clearInterval(timer);
                this.disabled1 = false;
                this.btnTitle = "获取验证码";
              } else {
                this.btnTitle = time + "秒后重试";
                this.disabled1 = true;
                time--;
              }
            }, 1000);
          }
        });
    }
  }
};
</script>

<style scoped>
.box {
  padding-top: 1px;
  /* background: #fff; */
  background: url("../assets/登录.png") center center repeat;
  height: 99%;
}
 
.login {
  width: 60%;
  height: 80%;
  margin: 15% auto 0;
}
.title {
  font-size: 25px;
  font-weight: 700;
  height: 10%;
  padding-left: 7%;
  color: rgba(51, 51, 51, 1);
}
.login-form-button {
  width: 89%;
  border: 0;
  border-radius: 50px;
  line-height: 30px;
  background: linear-gradient(
    135deg,
    rgba(172, 219, 86, 1) 0%,
    rgba(116, 180, 43, 1) 100%
  );
  color: #ffffff;
  margin-top: 20px;
  margin-bottom: 10px;
}
 
.checkbox {
  font-size: 12px;
  text-align: center;
  padding-left: 20px;
  position: fixed;
  bottom: 10%;
}
.protocol {
  color: rgba(116, 180, 43, 1);
  text-decoration: underline;
  font-size: 12px;
}
.van-checkbox{
  /* background-color: unset; */
  border: 0px;
}
.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
  border-width: 0;
}
.login_pass_p {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #444;
}
 
</style>